import { useFormContext } from 'react-hook-form'
import EdSwitch from '@/components/forms/EdSwitch'
import { useState } from 'react';

interface MixedDocumentsSectionProps {
  isReadOnly?: boolean;
}

const MixedDocumentsSection = ({ isReadOnly = false }: MixedDocumentsSectionProps) => {
  const { register, watch, setValue } = useFormContext();

  const [activeTab, setActiveTab] = useState<'fad' | 'aula'>('fad')
  const items = [
    { id: '1', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '2', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '3', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '4', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '5', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '6', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '7', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '8', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '9', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '10', name: 'Carlo Trainao', role: 'Tutor di processo' },


  ];

  const selections = watch('attoriSelezionati') || {};
  const selectionsObbligatorio = watch('attoriSelezionatiObbligatorio') || {};



  return (
    <div className="flex flex-col gap-1">
      <span className="text-[20px] text-[#4F4F4F] font-bold mt-2">Documenti di fine corso</span>
      <div className="flex mt-2">
        <span
          onClick={() => !isReadOnly && setActiveTab('fad')}
          className={`px-0 py-2 text-[20px] font-medium transition-colors shadow-none active:shadow-none focus:shadow-none ${isReadOnly ? 'cursor-default' : 'cursor-pointer'} ${
            activeTab === 'fad'
              ? 'text-[#B80F15] '
              : 'text-gray-500 hover:text-gray-700 active:text-[#B80F15]'
          }`}
        >
          FAD (3)
        </span>
        <div className="w-px bg-gray-200 mx-4"></div>
        <span
          onClick={() => !isReadOnly && setActiveTab('aula')}
          className={`px-0 py-2 text-[20px] font-medium transition-colors shadow-none active:shadow-none focus:shadow-none ${isReadOnly ? 'cursor-default' : 'cursor-pointer'} ${
            activeTab === 'aula'
              ? 'text-[#B80F15] '
              : 'text-gray-500 hover:text-gray-700 active:text-[#B80F15]'
          }`}
        >
          Aula (3)
        </span>
      </div>
      <div className="w-full ">
        {items.map((item, idx) => {
          const checked = !!selections?.[item.id];
          const mandatorio = !!selectionsObbligatorio?.[item.id];
          return (
            <div key={item.id} className={`flex items-center justify-between px-0 py-1.5 ${idx !== items.length - 1 ? 'border-b border-gray-200' : ''}`}>
              <div className="flex items-center gap-12">
                <span className="text-sm text-black min-w-[180px]">REGISTRO</span>
                <span className="text-sm text-[#6B7280]">AULA</span>
              </div>
              <div className="flex items-center gap-2">
                <EdSwitch
                  id={`attore-${item.id}`}
                  value={mandatorio}
                  onChange={() => setValue(`attoriSelezionatiObbligatorio.${item.id}`, !mandatorio, { shouldDirty: true })}
                  disabled={isReadOnly}
                />
                <span className={`text-sm ${mandatorio ? 'text-black' : 'text-gray-400'}`}>Obbligatorio</span>
              </div>
              <div className="flex items-center gap-2">
                <EdSwitch
                  id={`attore-${item.id}`}
                  value={checked}
                  onChange={() => setValue(`attoriSelezionati.${item.id}`, !checked, { shouldDirty: true })}
                  disabled={isReadOnly}
                />
                <span className={`text-sm ${checked ? 'text-black' : 'text-gray-400'}`}>Selezionato</span>
              </div>
            </div>
          );
        })}
      </div>
  
    </div>
  )
}

export default MixedDocumentsSection